import React from 'react';
import { Scope, withFormState } from 'informed';
import { get } from 'lodash';
import axios from 'axios';
import PropTypes from 'prop-types';
import InputTextAreaInformed from './InputTextAreaInformed';
import Button from './common/buttons/Button';
import { API_HOST } from '../consts';
import InputAsyncInformed from './InputAsyncInformed';
import DepartmentInput from './DepartmentInput';

const ResponsabilityForm = ({ onSubmit, submitting, formState }) => {
  const department = get(formState.values, 'responsability.department');
  const message = get(formState.values, 'responsability.message');
  const forwarded_to = get(formState.values, 'responsability.forwarded_to.id');

  const fetchDepartments = (search) => {
    if (department) {
      return axios
        .get(`${API_HOST}/declarations/departments/${department.id}/users`, {
          params: {
            search,
            permission: 'tickets-get_forwarding',
            is_active: true,
            page_size: 100,
            ordering: 'last_name',
          },
        })
        .then((response) => response.data.results);
    }
    return Promise.resolve([]);
  };

  const submitButtonIsDisabled =
    submitting || !department || !message || !forwarded_to;

  return (
    <>
      <div className="mb-3">
        <Scope scope="responsability">
          <div className="mb-3">
            <DepartmentInput />
            <div className="mt-1" />
            {department && (
              <InputAsyncInformed
                // Key is required to trigger loadOptions after a department change
                key={department.id}
                defaultOptions
                field="forwarded_to"
                placeholder="Destinatário"
                loadOptions={fetchDepartments}
                getOptionLabel={(option) => option.nome}
                getOptionValue={(option) => option.id}
              />
            )}
          </div>
          {forwarded_to && (
            <InputTextAreaInformed
              field="message"
              placeholder="Justifique a transferência de responsabilidade"
            />
          )}
        </Scope>
      </div>
      <div className="mt-3" />
      <Button
        disabled={submitButtonIsDisabled}
        action="primary"
        onClick={onSubmit}
      >
        TRANSFERIR RESPONSABILIDADE
      </Button>
    </>
  );
};

ResponsabilityForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  formState: PropTypes.shape({
    values: PropTypes.object,
  }).isRequired,
};

ResponsabilityForm.defaultProps = {
  submitting: false,
};

export default withFormState(ResponsabilityForm);
